export default __webpack_public_path__ + "static/media/COPD-Acute.a70ed375.jpg";